/**
 * Client-side Configuration Helper
 * 
 * Bu yardımcı, uygulamanın çalışma zamanı (runtime) yapılandırmasını 
 * veya build-time (process.env) yapılandırmasını döndürür.
 * Runtime yapılandırma, sunucu tarafından index.html içine enjekte edilir.
 * 
 * Bu yapılandırma artık src/config.json dosyasından da beslenebilir.
 */

import appConfig from '../config.persistent.json';

const getClientConfig = () => {
    // Sunucu tarafından enjekte edilen runtime config
    const runtimeConfig = window.__RUNTIME_CONFIG__ || {};

    return {
        REACT_APP_API_BASE_URL: runtimeConfig.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || '',
        REACT_APP_API_URL: runtimeConfig.REACT_APP_API_URL || process.env.REACT_APP_API_URL || runtimeConfig.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || '',
        REACT_APP_SOCKET_URL: runtimeConfig.REACT_APP_SOCKET_URL || process.env.REACT_APP_SOCKET_URL || runtimeConfig.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || '',
        REACT_APP_ENV: runtimeConfig.REACT_APP_ENV || process.env.REACT_APP_ENV || 'development',
        REACT_APP_CALL_WEB_SDK_URL: runtimeConfig.REACT_APP_CALL_WEB_SDK_URL || process.env.REACT_APP_CALL_WEB_SDK_URL || '',
        REACT_APP_SDK_API_KEY: runtimeConfig.REACT_APP_SDK_API_KEY || process.env.REACT_APP_SDK_API_KEY || '',
        REACT_APP_KYC_BACKEND_BASE_URL: runtimeConfig.REACT_APP_KYC_BACKEND_BASE_URL || process.env.REACT_APP_KYC_BACKEND_BASE_URL || '',
        REACT_APP_KYCSERVER_API_KEY: runtimeConfig.REACT_APP_KYCSERVER_API_KEY || process.env.REACT_APP_KYCSERVER_API_KEY || '',
        REACT_APP_STUN_SERVERS: runtimeConfig.REACT_APP_STUN_SERVERS || process.env.REACT_APP_STUN_SERVERS || 'stun:stun.l.google.com:19302',
        REACT_APP_TURN_SERVER_1_URLS: runtimeConfig.REACT_APP_TURN_SERVER_1_URLS || process.env.REACT_APP_TURN_SERVER_1_URLS || '',
        REACT_APP_TURN_SERVER_1_USERNAME: runtimeConfig.REACT_APP_TURN_SERVER_1_USERNAME || process.env.REACT_APP_TURN_SERVER_1_USERNAME || '',
        REACT_APP_TURN_SERVER_1_CREDENTIAL: runtimeConfig.REACT_APP_TURN_SERVER_1_CREDENTIAL || process.env.REACT_APP_TURN_SERVER_1_CREDENTIAL || '',
        REACT_APP_LOG_ON: appConfig.REACT_APP_LOG_ON === true || runtimeConfig.REACT_APP_LOG_ON === 'true' || process.env.REACT_APP_LOG_ON === 'true' || false,
        REACT_APP_AGENT_SUFFIX: runtimeConfig.REACT_APP_AGENT_SUFFIX || process.env.REACT_APP_AGENT_SUFFIX || '',
    };
};

export default getClientConfig();
